'use strict';

var jsxRuntime = require('react/jsx-runtime');

const Calendar = ({ disabled = false })=>{
    if (disabled) {
        return jsxRuntime.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "60",
            height: "60",
            viewBox: "0 0 60 60",
            fill: "none",
            "data-testid": "design-system-productIcon-icon-calendar--disabled",
            children: [
                jsxRuntime.jsx("path", {
                    d: "M46.3667 17.5513C46.7014 15.1461 44.8332 13 42.4049 13H14.2127C12.2166 13 10.526 14.4717 10.2509 16.4487L6.63326 42.4487C6.29861 44.8539 8.16677 47 10.5951 47H38.7873C40.7834 47 42.474 45.5283 42.7491 43.5513L46.3667 17.5513Z",
                    fill: "white",
                    stroke: "#9E9E9E",
                    strokeWidth: "1.4"
                }),
                jsxRuntime.jsx("path", {
                    d: "M10.6506 17.5644C10.3072 15.1551 12.1769 13 14.6106 13H43.6835C45.6746 13 47.3626 14.4644 47.6435 16.4356L51.3494 42.4356C51.6928 44.8449 49.8231 47 47.3894 47H18.3164C16.3254 47 14.6374 45.5356 14.3565 43.5644L10.6506 17.5644Z",
                    fill: "white",
                    stroke: "#9E9E9E",
                    strokeWidth: "1.4"
                }),
                jsxRuntime.jsx("path", {
                    d: "M30 34L34 34",
                    stroke: "#9E9E9E",
                    strokeWidth: "1.4",
                    strokeLinecap: "round"
                }),
                jsxRuntime.jsx("path", {
                    d: "M21 34L25 34",
                    stroke: "#9E9E9E",
                    strokeWidth: "1.4",
                    strokeLinecap: "round"
                }),
                jsxRuntime.jsx("path", {
                    d: "M31 39L35 39",
                    stroke: "#9E9E9E",
                    strokeWidth: "1.4",
                    strokeLinecap: "round"
                }),
                jsxRuntime.jsx("path", {
                    d: "M22 39L26 39",
                    stroke: "#9E9E9E",
                    strokeWidth: "1.4",
                    strokeLinecap: "round"
                }),
                jsxRuntime.jsx("path", {
                    d: "M29 29L33 29",
                    stroke: "#9E9E9E",
                    strokeWidth: "1.4",
                    strokeLinecap: "round"
                }),
                jsxRuntime.jsx("path", {
                    d: "M20 29L24 29",
                    stroke: "#9E9E9E",
                    strokeWidth: "1.4",
                    strokeLinecap: "round"
                }),
                jsxRuntime.jsx("path", {
                    d: "M38 29L42 29",
                    stroke: "#9E9E9E",
                    strokeWidth: "1.4",
                    strokeLinecap: "round"
                }),
                jsxRuntime.jsx("circle", {
                    cx: "48",
                    cy: "42",
                    r: "8",
                    fill: "#E0E0E0",
                    stroke: "#9E9E9E",
                    strokeWidth: "1.4"
                }),
                jsxRuntime.jsx("path", {
                    d: "M48 38V42H52",
                    stroke: "white",
                    strokeWidth: "1.4",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                jsxRuntime.jsx("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M48.4362 22H11.2824L10.6501 17.5644C10.3067 15.1551 12.1764 13 14.6101 13H43.6831C45.6742 13 47.3621 14.4644 47.6431 16.4356L48.4362 22Z",
                    fill: "#E0E0E0"
                }),
                jsxRuntime.jsx("path", {
                    d: "M48.4362 22V22.7H49.2431L49.1292 21.9012L48.4362 22ZM11.2824 22L10.5894 22.0988L10.6751 22.7H11.2824V22ZM10.6501 17.5644L11.3431 17.4657L10.6501 17.5644ZM47.6431 16.4356L46.9501 16.5343V16.5343L47.6431 16.4356ZM48.4362 21.3H11.2824V22.7H48.4362V21.3ZM11.9754 21.9012L11.3431 17.4657L9.95715 17.6632L10.5894 22.0988L11.9754 21.9012ZM11.3431 17.4657C11.0598 15.478 12.6023 13.7 14.6101 13.7V12.3C11.7505 12.3 9.55364 14.8322 9.95715 17.6632L11.3431 17.4657ZM14.6101 13.7H43.6831V12.3H14.6101V13.7ZM43.6831 13.7C45.3258 13.7 46.7183 14.9081 46.9501 16.5343L48.3361 16.3368C48.006 14.0207 46.0226 12.3 43.6831 12.3V13.7ZM46.9501 16.5343L47.7432 22.0988L49.1292 21.9012L48.3361 16.3368L46.9501 16.5343Z",
                    fill: "#9E9E9E"
                }),
                jsxRuntime.jsx("path", {
                    d: "M18.175 10.7505C18.0813 9.81325 18.8173 9 19.7592 9C20.5771 9 21.262 9.61978 21.3434 10.4336L21.825 15.2495C21.9187 16.1867 21.1827 17 20.2408 17C19.4229 17 18.738 16.3802 18.6566 15.5664L18.175 10.7505Z",
                    fill: "white",
                    stroke: "#9E9E9E",
                    strokeWidth: "1.4"
                }),
                jsxRuntime.jsx("path", {
                    d: "M36.175 10.7505C36.0813 9.81325 36.8173 9 37.7592 9C38.5771 9 39.262 9.61978 39.3434 10.4336L39.825 15.2495C39.9187 16.1867 39.1827 17 38.2408 17C37.4229 17 36.738 16.3802 36.6566 15.5664L36.175 10.7505Z",
                    fill: "white",
                    stroke: "#9E9E9E",
                    strokeWidth: "1.4"
                })
            ]
        });
    }
    return jsxRuntime.jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "60",
        height: "60",
        viewBox: "0 0 60 60",
        fill: "none",
        "data-testid": "design-system-productIcon-icon-calendar",
        className: "text-primary",
        children: [
            jsxRuntime.jsx("path", {
                d: "M46.3667 17.5513C46.7014 15.1461 44.8332 13 42.4049 13H14.2127C12.2166 13 10.526 14.4717 10.2509 16.4487L6.63326 42.4487C6.29861 44.8539 8.16677 47 10.5951 47H38.7873C40.7834 47 42.474 45.5283 42.7491 43.5513L46.3667 17.5513Z",
                fill: "white",
                stroke: "#212121",
                strokeWidth: "1.4"
            }),
            jsxRuntime.jsx("path", {
                d: "M10.6506 17.5644C10.3072 15.1551 12.1769 13 14.6106 13H43.6836C45.6746 13 47.3626 14.4644 47.6435 16.4356L51.3494 42.4356C51.6928 44.8449 49.8231 47 47.3894 47H18.3164C16.3254 47 14.6374 45.5356 14.3565 43.5644L10.6506 17.5644Z",
                fill: "white",
                stroke: "#212121",
                strokeWidth: "1.4"
            }),
            jsxRuntime.jsx("path", {
                d: "M30 34L34 34",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinecap: "round"
            }),
            jsxRuntime.jsx("path", {
                d: "M21 34L25 34",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinecap: "round"
            }),
            jsxRuntime.jsx("path", {
                d: "M31 39L35 39",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinecap: "round"
            }),
            jsxRuntime.jsx("path", {
                d: "M22 39L26 39",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinecap: "round"
            }),
            jsxRuntime.jsx("path", {
                d: "M29 29L33 29",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinecap: "round"
            }),
            jsxRuntime.jsx("path", {
                d: "M20 29L24 29",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinecap: "round"
            }),
            jsxRuntime.jsx("path", {
                d: "M38 29L42 29",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinecap: "round"
            }),
            jsxRuntime.jsx("circle", {
                cx: "48",
                cy: "42",
                r: "8",
                fill: "currentColor",
                stroke: "#212121",
                strokeWidth: "1.4"
            }),
            jsxRuntime.jsx("path", {
                d: "M48 38V42H52",
                stroke: "white",
                strokeWidth: "1.4",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            jsxRuntime.jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M48.4362 22H11.2824L10.6501 17.5644C10.3067 15.1551 12.1764 13 14.6101 13H43.6831C45.6742 13 47.3621 14.4644 47.6431 16.4356L48.4362 22Z",
                fill: "currentColor"
            }),
            jsxRuntime.jsx("path", {
                d: "M48.4362 22V22.7H49.2431L49.1292 21.9012L48.4362 22ZM11.2824 22L10.5894 22.0988L10.6751 22.7H11.2824V22ZM10.6501 17.5644L11.3431 17.4657L10.6501 17.5644ZM47.6431 16.4356L46.9501 16.5343V16.5343L47.6431 16.4356ZM48.4362 21.3H11.2824V22.7H48.4362V21.3ZM11.9754 21.9012L11.3431 17.4657L9.95715 17.6632L10.5894 22.0988L11.9754 21.9012ZM11.3431 17.4657C11.0598 15.478 12.6023 13.7 14.6101 13.7V12.3C11.7505 12.3 9.55364 14.8322 9.95715 17.6632L11.3431 17.4657ZM14.6101 13.7H43.6831V12.3H14.6101V13.7ZM43.6831 13.7C45.3258 13.7 46.7183 14.9081 46.9501 16.5343L48.3361 16.3368C48.006 14.0207 46.0226 12.3 43.6831 12.3V13.7ZM46.9501 16.5343L47.7432 22.0988L49.1292 21.9012L48.3361 16.3368L46.9501 16.5343Z",
                fill: "#212121"
            }),
            jsxRuntime.jsx("path", {
                d: "M18.175 10.7505C18.0813 9.81325 18.8173 9 19.7592 9C20.5771 9 21.262 9.61978 21.3434 10.4336L21.825 15.2495C21.9187 16.1867 21.1827 17 20.2408 17C19.4229 17 18.738 16.3802 18.6566 15.5664L18.175 10.7505Z",
                fill: "white",
                stroke: "#212121",
                strokeWidth: "1.4"
            }),
            jsxRuntime.jsx("path", {
                d: "M36.175 10.7505C36.0813 9.81325 36.8173 9 37.7592 9C38.5771 9 39.262 9.61978 39.3434 10.4336L39.825 15.2495C39.9187 16.1867 39.1827 17 38.2408 17C37.4229 17 36.738 16.3802 36.6566 15.5664L36.175 10.7505Z",
                fill: "white",
                stroke: "#212121",
                strokeWidth: "1.4"
            })
        ]
    });
};

module.exports = Calendar;
